export default {
  home: 'Hjem',
  settings: 'Innstillinger',
  logoAlt: 'logo',
  groups: {
    prod: 'Produksjon & Lager',
    excise: 'Avgifter & Etterlevelse',
    sales: 'Salg & Finans',
    tools: 'Verktøy & Administrasjon',
    wiki: 'Wiki',
  },
  menu: {
    inventory: 'Inventar',
    agp: 'AGP',
    recipes: 'Oppskrifter',
    batches: 'Batcher',
    'shopping-list': 'Handleliste',
    stock: 'Lager',
    planning: 'Planlegging',
    tools: 'Verktøy',
    invoices: 'Fakturaer',
    audit: 'Revisjon',
    suggestions: 'Forslag',
    wiki: 'Wiki',
  },
};
